import { useQueryClient } from '@tanstack/react-query';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { APP_VERSION, APP_VERSION_LABEL } from '../version';

/**
 * Chrome around every authenticated route.
 *
 * The header is exactly 64px tall — `GeologistWorkspace.css` sizes the
 * workspace with `calc(100vh - 64px)`, so the shell and that stylesheet share
 * this contract. Changing the height here requires changing it there.
 */
const NAV_ITEMS = [
  { to: '/agents/geologist/workspace', label: 'Рабочее место' },
  { to: '/agents', label: 'Студия агентов' },
] as const;

export default function AppShell() {
  const { user, signOut } = useAuth();
  const queryClient = useQueryClient();

  const handleSignOut = () => {
    // Drop every cached response before the session ends so that a subsequent
    // sign-in cannot briefly render the previous user's data.
    queryClient.clear();
    signOut();
  };

  return (
    <div className="app-shell">
      <header className="app-shell__header">
        <div className="app-shell__brand">
          <span className="app-shell__mark" aria-hidden="true" />
          <span className="app-shell__product">AI-Геолог</span>
          <span
            className="app-shell__version"
            title={`Версия приложения ${APP_VERSION}`}
            data-testid="app-version"
          >
            {APP_VERSION_LABEL}
          </span>
        </div>

        <nav className="app-shell__nav" aria-label="Основная навигация">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                isActive ? 'app-shell__link app-shell__link--active' : 'app-shell__link'
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="app-shell__account">
          {user ? (
            <span className="app-shell__email" title={user.email}>
              {user.email}
            </span>
          ) : null}
          <button type="button" className="button button--quiet" onClick={handleSignOut}>
            Выйти
          </button>
        </div>
      </header>

      <main className="app-shell__main">
        <Outlet />
      </main>
    </div>
  );
}
